import { Component } from '@angular/core';
import { DashboardWrapperComponent } from '../../components/dashboard-wrapper/dashboard-wrapper.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { UserInfoSettingsComponent } from './components/user-info-settings/user-info-settings.component';
import { BusinessInfoSettingsComponent } from './components/business-info-settings/business-info-settings.component';
import { ResetPasswordSettingsComponent } from './components/reset-password-settings/reset-password-settings.component';
import { DashboardService } from '../../dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { CopyCodePopupComponent } from './components/copy-code-popup/copy-code-popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from 'app/services/application.service';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from 'app/components/modal/modal.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
    selector: 'app-profile-settings',
    standalone: true,
    imports: [
        DashboardWrapperComponent,
        TranslateModule,
        CommonModule,
        MatIconModule,
        MatProgressBarModule,
        ResetPasswordSettingsComponent,
        UserInfoSettingsComponent,
        BusinessInfoSettingsComponent,
    ],
    templateUrl: './profile-settings.component.html',
    styleUrl: './profile-settings.component.scss',
})
export class ProfileSettingsComponent {
    currentTab: 'profile' | 'change-password' = 'profile';
    currentProfileSubTab: 'user-info' | 'business-info' = 'user-info';

    mainTabsData = [
        {
            label: 'COMMON.PROFILE',
            value: 'profile',
        },
        {
            label: 'RESET_PASSWORD.RESET_PASSWORD_TITLE',
            value: 'change-password',
        },
    ];

    subTabsData = [
        // {
        //     name: 'PROFILE.UPLOAD_PROFILE_PIC',
        //     tab: 'profile',
        //     isProfileDetailsComplete: false,
        // },
        {
            name: 'PROFILE.USER_INFO',
            tab: 'user-info',
            isProfileDetailsComplete: false,
        },
        {
            name: 'NEW_APPLICATION.BUSINESS_INFO',
            tab: 'business-info',
            isProfileDetailsComplete: false,
        },
    ];
    userData: any;
    previewImageUrl: string | ArrayBuffer | null = null;
    profileCompletionPercent = 0;
    isProfileDetailsComplete: boolean;
    isBusinessDetailsComplete: boolean;
    getUtmId: any;
    getUtmSource: any;
    isAuthenticated: boolean = false;
    caseId: any;

    constructor(
        private _dashService: DashboardService,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private applicationService: ApplicationService,
        private router: Router,
        private toastr: ToastrService,
    ) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;

        // if user came from financing application page, check for draft application
        this.route.queryParams.subscribe((params) => {
            const financingApp = params['financingApp'];
            if (financingApp === 'true') {
                this.checkMatchingProducts();
            }
        });

        // Set the initial active route based on current URL
        this.userData = this._dashService.getUser();
        this._dashService.getProfileImageUrl$().subscribe((url) => {
            this.previewImageUrl = url ?? '/assets/images/placeholder.webp';
            if (this.userData && this.previewImageUrl) {
                const profileStatus = this._dashService.getProfileCompletion(
                    this.userData,
                    this.previewImageUrl,
                );
                this.profileCompletionPercent = profileStatus.completion;
                this.isProfileDetailsComplete =
                    profileStatus.isProfileDetailsComplete;
                this.isBusinessDetailsComplete =
                    profileStatus.isBusinessDetailsComplete;
                this.subTabsData = this.subTabsData.map((tab) => {
                    if (tab.tab === 'user-info') {
                        return {
                            ...tab,
                            isProfileDetailsComplete:
                                this.isProfileDetailsComplete,
                        };
                    }
                    if (tab.tab === 'business-info') {
                        return {
                            ...tab,
                            isBusinessDetailsComplete:
                                this.isBusinessDetailsComplete,
                        };
                    }
                    return tab;
                });
            }
        });
    }

    ngOnInit() {
        this.getUtmId = JSON.parse(sessionStorage.getItem('utm_id'));
        this.getUtmSource = JSON.parse(sessionStorage.getItem('utm_source'));
    }

    changeCurrentTab(tab) {
        this.currentTab = tab;
    }

    changeCurrentProfileSubTab(tab) {
        this.currentProfileSubTab = tab;
    }

    openCopyDialog() {
        this.dialog.open(CopyCodePopupComponent, {
            width: '100%',
            maxWidth: '618px',
            height: '405px',
            panelClass: 'copy-code-popup',
            data: {
                referralCode: this.userData.myReferralCode,
            },
        });
    }

    // financing applicaation flow functions
    checkMatchingProducts(draftStatus?) {
        let productData = {};

        if (draftStatus == 'startNewApp') {
            productData['deleteAndContinue'] = true;
        }

        if (this.getUtmSource && this.getUtmId == 'BRP') {
            productData['source'] = this.getUtmSource;
        } else if (this.getUtmId == 'CIDB') {
            productData['source'] = this.getUtmId;
        }

        if (this.isAuthenticated) {
            this.applicationService.createCaseProduct(productData).subscribe({
                next: (res: any) => {
                    let response = res;
                    if (response.drafts) {
                        let draftData = response.drafts;
                        if (
                            draftData.length > 0 &&
                            draftStatus !== 'startNewApp'
                        ) {
                            let selectedProductCode =
                                draftData[0].selectedProducts;
                            let selectedProductName = draftData[0].productName;
                            this.confirmDraftDialog(
                                draftData,
                                selectedProductCode,
                                'checkMatchingProducts',
                                selectedProductName,
                            );
                        } else if (
                            draftData.length > 0 &&
                            draftStatus == 'startNewApp'
                        ) {
                            draftData.forEach((element) => {
                                this.caseId = element.caseId;
                            });
                            this.router.navigate(['/corporate'], {
                                state: {
                                    setProductDetails: this.caseId,
                                    checkMatchingProduct: true,
                                },
                            });
                        }
                    } else {
                        response.forEach((element) => {
                            this.caseId = element.caseId;
                        });
                        this.router.navigate(['/corporate'], {
                            state: {
                                setProductDetails: this.caseId,
                                checkMatchingProduct: true,
                            },
                        });
                    }
                },
                error: (err) => {
                    this.toastr.error(err.error.message);
                },
            });
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: `/business-financing`,
                },
            });
        }
    }

    confirmDraftDialog(
        draftData,
        selectedProductCode?,
        appProductFlow?,
        selectedProductName?,
        prodCode?,
    ) {
        let noOfDrafts = draftData.length;
        const dialogRef = this.dialog.open(ModalComponent, {
            data: {
                noOfDrafts,
            },
            scrollStrategy: new NoopScrollStrategy(),
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.data == 'resumeDraft') {
                draftData.forEach((element) => {
                    this.caseId = element.caseId;
                });
                let qType;
                draftData.map((ele) => {
                    qType = ele.qType;
                });
                this.resumeApp(
                    this.caseId,
                    qType,
                    selectedProductCode,
                    selectedProductName,
                );
            } else if (result.data == 'startNewApp') {
                if (appProductFlow == 'checkMatchingProducts') {
                    this.checkMatchingProducts('startNewApp');
                    // } else if (appProductFlow == 'selectProduct') {
                    //     this.onSelectProduct(prodCode, 'startNewApp');
                    // }
                }
            }
        });
    }

    resumeApp(
        caseId: string,
        qType: string,
        selectedProduct?: string,
        selectedProductName?: string,
    ) {
        const matchedProductsFlowArr = [
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGC_USR_INFO',
            'LOAN_CGC_UPD_USR_INFO',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGC_BSNS_INFO',
            'LOAN_CGC_FI_OFFR_SCR',
            'LOAN_CGC_UPLD_DOC',
        ];
        const selectProductFlowArr = [
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGCP_UPD_USR_INFO',
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGCP_BSNS_INFO',
            'LOAN_CGCP_chk_elig',
            'LOAN_CGCP_UPLD_DOC',
        ];
        let appProductFlow;
        let isMatchedProductsFlow;
        if (matchedProductsFlowArr.includes(qType)) {
            appProductFlow = 'checkMatchingProducts';
            isMatchedProductsFlow = true;
        } else if (selectProductFlowArr.includes(qType)) {
            appProductFlow = 'selectProduct';
            isMatchedProductsFlow = false;
        }

        const navigationExtras = {
            state: {
                fromResume: true,
            },
        };
        if (appProductFlow == 'checkMatchingProducts') {
            navigationExtras.state['checkMatchingProduct'] = true;
        }

        if (this.getAppStepNo(qType) == 1) {
            navigationExtras.state['setProductDetails'] = caseId;
            navigationExtras.state['productName'] = selectedProductName;
            this.router.navigate(['/corporate'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 2) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 3) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 4) {
            //check-eligibility flow
            let productFlowData = {
                caseId: caseId,
                prodCode: selectedProduct,
                productFlow: isMatchedProductsFlow,
            };
            navigationExtras.state['productFlowData'] = productFlowData;
            this.router.navigate(['/business-info'], navigationExtras);
        } else {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/corporate'], navigationExtras);
        }
    }

    getAppStepNo(qType: string) {
        let step1Arr = [
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGC_USR_INFO',
        ];
        let step2Arr = ['LOAN_CGCP_UPD_USR_INFO', 'LOAN_CGC_UPD_USR_INFO'];
        let step3Arr = ['LOAN_CGCP_BSNS_INFO', 'LOAN_CGC_BSNS_INFO'];
        let step4Arr = ['LOAN_CGCP_chk_elig', 'LOAN_CGC_FI_OFFR_SCR'];
        let step5Arr = ['LOAN_CGCP_UPLD_DOC', 'LOAN_CGC_UPLD_DOC'];
        if (step1Arr.includes(qType)) {
            return 1;
        } else if (step2Arr.includes(qType)) {
            return 2;
        } else if (step3Arr.includes(qType)) {
            return 3;
        } else if (step4Arr.includes(qType)) {
            return 4;
        } else if (step5Arr.includes(qType)) {
            return 4;
        }
    }
}
